import axios from 'axios';
import config from '../config';
import { ProcessingBuildRequestProps } from '../interfaces';

type CreateProcessingBuildPayload = ProcessingBuildRequestProps & {
    tileSourcePriorities?: string[];
};

export const createProcessingBuild = (zone: CreateProcessingBuildPayload) => {
    const url = `${config.API_URL}/maps/processing-builds`;

    return axios.post(url, zone).then((response: any) => {
        return response.data.data;
    });
};
